import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { ArrowRight2 } from "iconsax-react";
import { ElementType, FC, HTMLAttributes } from "react";
import { Link } from "react-router-dom";
import { Progress } from "./ui/progress";

type DimensionSummaryCardProps = HTMLAttributes<HTMLDivElement> & {
  dimensionId: string;
  editionId: string;
  title: string;
  description: string;
  color?: string;
  icon?: ElementType;
  totalTopics: number;
  completedTopics: number;
  buttonText?: string;
  showExtraInfo: boolean;
  completedPercentage: number;
  scoreProportion?: number;
  sbowScoreProportionInHeader?: boolean;
  useCompactStyle?: boolean;
};

const DimensionSummaryCard: FC<DimensionSummaryCardProps> = ({
  className,
  icon: Icon,
  buttonText = "Ir a la dimensión",
  showExtraInfo,
  sbowScoreProportionInHeader = true,
  useCompactStyle = false,
  ...props
}) => {
  const finalColor = props.color || "#f1f5f9";

  const showWeight =
    showExtraInfo && props.dimensionId !== "COMPANY_INFORMATION";

  return (
    <Card className={className}>
      <CardContent className="flex h-full flex-col gap-4 pt-6">
        <div className={cn("flex grow gap-2", useCompactStyle && "flex-col")}>
          <div
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-white"
            style={{ background: finalColor }}
          >
            {Icon && <Icon size={20} />}
          </div>

          <div className="flex flex-grow flex-col">
            <h2 className="text-sm font-semibold text-[#293038]">
              {props.title}
            </h2>

            <p className="mt-1 text-xs text-[#4F5D6D]">{props.description}</p>

            {sbowScoreProportionInHeader && props.scoreProportion != null && (
              <p className="mt-1 text-xs font-bold text-[#8090A3]">
                Puntaje Ponderado: {props.scoreProportion} puntos
              </p>
            )}
          </div>
        </div>

        <div className="flex gap-6">
          <p className="text-xs text-[#293038]">
            <strong className="block font-bold">Has completado</strong>
            <span>
              {props.completedTopics}/{props.totalTopics} temas
            </span>
          </p>

          {showWeight && props.scoreProportion != null && (
            <p className="text-xs text-[#293038]">
              <strong className="block font-bold">Puntaje Ponderado</strong>
              <span>{props.scoreProportion} puntos</span>
            </p>
          )}
        </div>

        {showExtraInfo && (
          <div className="grow">
            <div className="text-xs font-medium text-[#8090A3]">
              {props.completedPercentage}%
            </div>
            <Progress
              value={props.completedPercentage}
              className="h-2"
              indicatorColor={props.color}
            />
          </div>
        )}

        <Button
          className="w-full"
          style={{ backgroundColor: props.color }}
          asChild
        >
          <Link
            to={`/editions/${props.editionId}/quiz/dimensions/${props.dimensionId}`}
          >
            {buttonText} <ArrowRight2 size={16} />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
};

export default DimensionSummaryCard;
